export default __webpack_public_path__ + "static/media/6.4f25df71.svg";